module.exports = __webpack_public_path__ + "static/img/de_pic.00f2280.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/de_pic.jpg
// module id = hyHk
// module chunks = 37